import { AbsenceReportApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { UpcomingAbsenceDto } from '../../../commonTypes/reports.types';
import { fetchAllReportRows } from '../../../util/exportHelper';

export interface IGetUpcomingAbsencesForExportQuery {
    month: number;
    year: number;
    teamId?: string;
    projectId?: string;
    leaveType?: string;
    search?: string;
}

const useHttpGetUpcomingAbsencesForExport = () => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);

    const exec = (query: IGetUpcomingAbsencesForExportQuery): Promise<UpcomingAbsenceDto[]> =>
        fetchAllReportRows(
            (page, size) =>
                new Promise((resolve, reject) => {
                    const { exec } = absenceReportApi.getUpcomingAbsences({
                        query: { ...query, page, size },
                        onSuccess: res => resolve(res.body),
                        onError: reject,
                    });
                    exec();
                })
        );

    return { exec };
};

export default useHttpGetUpcomingAbsencesForExport;
